import { render, staticRenderFns } from "./CsvUploadArea.vue?vue&type=template&id=0a589b04&scoped=true&"
import script from "./CsvUploadArea.vue?vue&type=script&lang=js&"
export * from "./CsvUploadArea.vue?vue&type=script&lang=js&"
import style0 from "./CsvUploadArea.vue?vue&type=style&index=0&id=0a589b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a589b04",
  null
  
)

export default component.exports